export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8709.898cbe4c.jpg";